module.exports = __webpack_public_path__ + "lider.png?571255c5974b2edfca2b7e5e2d5412fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lider.png
// module id = 395
// module chunks = 0